/**
 * Easy Subscriptions Widget Enhancer
 * Unified Organic Green Theme (No Pink/Purple)
 * - Default: Regular Purchase Selected on Load
 * - Dynamic Active State Switching: Monthly, Quarterly, Yearly, and Regular
 * - Monthly has NO discount badge (App original status)
 * - Quarterly & Yearly height-aligned with Monthly
 * - Full Subscribe Now button creation & synchronization
 * - Comma-formatted prices, stripped decimals from discounts
 * - Scoped strictly to .easymanualsubsection
 */
(function() {
  'use strict';

  var userHasInteracted = false;

  // SVG Icons with unified green palette
  var CART_ICON_SVG = '<span class="subx-icon-wrap--cart" aria-hidden="true"><svg class="subx-icon subx-icon--cart" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#111827" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg></span>';
  
  var REFRESH_ICON_SVG = '<span class="subx-icon-badge subx-icon-badge--green" aria-hidden="true"><svg class="subx-icon subx-icon--refresh" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#284835" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="23 4 23 10 17 10"></polyline><polyline points="1 20 1 14 7 14"></polyline><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path></svg></span>';
  
  var CALENDAR_GREEN_SVG = '<span class="subx-icon-badge subx-icon-badge--green" aria-hidden="true"><svg class="subx-icon subx-icon--calendar" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#284835" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg></span>';

  // Ensure Subscribe Now button is created next to Add to Cart button
  function ensureSubscribeButton() {
    var targets = document.querySelectorAll('.fresh-buy, .product-form__buttons, form[action*="/cart/add"], product-form, .product-form');
    targets.forEach(function(container) {
      var nativeBtn = container.querySelector('button[name="add"], [id^="ProductSubmitButton-"], .product-form__submit[name="add"], button[type="submit"]:not(.subx__subscribe-btn)');
      if (!nativeBtn) return;

      var subBtn = container.querySelector('.subx__subscribe-btn, .subx-subscribe-btn');
      if (!subBtn) {
        subBtn = nativeBtn.cloneNode(true);
        subBtn.className = (nativeBtn.className || '') + ' subx__subscribe-btn';
        subBtn.removeAttribute('id');
        subBtn.removeAttribute('name');
        subBtn.removeAttribute('ref');
        subBtn.type = 'button';
        subBtn.disabled = false;
        
        var span = subBtn.querySelector('span');
        if (span) {
          span.textContent = 'Subscribe Now';
        } else {
          subBtn.textContent = 'Subscribe Now';
        }

        subBtn.style.setProperty('display', 'none', 'important');

        subBtn.addEventListener('click', function(e) {
          e.preventDefault();
          var primarySubxBtn = document.querySelector('.subx__subscribe-btn:not([data-subx-fallback])');
          if (primarySubxBtn && primarySubxBtn !== subBtn) {
            primarySubxBtn.click();
            return;
          }
          if (window.SUBX && typeof window.SUBX.openCheckoutPopup === 'function') {
            var form = subBtn.closest('form') || document.querySelector('form[action*="/cart/add"]');
            window.SUBX.openCheckoutPopup(window.SUBX.getSubxPopupData(form));
          } else if (typeof window.handleSubscribeButtonClick === 'function') {
            window.handleSubscribeButtonClick(e);
          } else {
            var f = subBtn.closest('form') || document.querySelector('form[action*="/cart/add"]');
            if (f) f.submit();
          }
        });

        subBtn.setAttribute('data-subx-fallback', 'true');
        nativeBtn.insertAdjacentElement('afterend', subBtn);
      }
    });
  }

  // Strip .00 decimals from all discount percentage badges (e.g. SAVE 15.00% -> SAVE 15%)
  function formatDiscountBadges(root) {
    var badges = root.querySelectorAll('.easydiscountbadge');
    badges.forEach(function(badge) {
      if (badge && badge.textContent) {
        var updated = badge.textContent.replace(/\.00(?=%)/g, '').replace(/(\.\d*?[1-9])0+(?=%)/g, '$1');
        if (badge.textContent !== updated) {
          badge.textContent = updated;
        }
      }
    });
  }

  // Format numbers >= 1000 with Indian currency commas (e.g. ₹ 1377.00 -> ₹ 1,377.00)
  function formatPrices(root) {
    var priceEls = root.querySelectorAll('.easysellingplanallocationprice, .easysellingplanvariantprice, .easymsgregularprice, .easymsgsubsplanprice');
    priceEls.forEach(function(el) {
      if (el && el.childNodes) {
        el.childNodes.forEach(function(node) {
          if (node.nodeType === Node.TEXT_NODE && node.nodeValue) {
            var formatted = node.nodeValue.replace(/(\d{4,})(\.\d+)?/g, function(match, intPart, decPart) {
              return Number(intPart).toLocaleString('en-IN') + (decPart || '');
            });
            if (node.nodeValue !== formatted) {
              node.nodeValue = formatted;
            }
          }
        });
      }
    });
  }

  // Normalize subtitles casing (e.g. "Delivery every 1 Month, prepay 3 Months" -> "Delivery every 1 month, prepay 3 months")
  function formatSubtitles(root) {
    var subEls = root.querySelectorAll('.easysellingplanprepaidinfo');
    subEls.forEach(function(el) {
      if (el && el.textContent) {
        var clean = el.textContent
          .replace(/Month\b/g, 'month')
          .replace(/Months\b/g, 'months');
        if (el.textContent !== clean) {
          el.textContent = clean;
        }
      }
    });
  }

  // Master selection handler: switches active states dynamically
  function selectPurchaseOption(type, targetCardIndex) {
    var subsection = document.querySelector('.easymanualsubsection');
    if (!subsection) return;

    ensureSubscribeButton();

    var oneTimeContainer = subsection.querySelector('.easymsgonetimecontainer');
    var oneTimeLabel = subsection.querySelector('.easymsgonetimelabel');
    var oneTimeRadio = subsection.querySelector('.easymsgonetimecontainer input[type="radio"], input[id^="one_time_purchase_option"]');

    var subxGroup = subsection.querySelector('.easymsggroupcontainer');
    var subsHeaderRadio = subsection.querySelector('.easymsgsubsplancontainer input[type="radio"], input[id^="selling_plan_purchase_option"]:not(.easymsgsamllradio)');
    var planCards = subsection.querySelectorAll('.easymsgsubsplanlistcontainerlabCon');

    var atcButtons = document.querySelectorAll('button[name="add"], [id^="ProductSubmitButton-"], .product-form__submit[name="add"]');
    var buyNowButtons = document.querySelectorAll('button[name="checkout"], .nupi-buy-now-btn, button.product-form__submit[name="checkout"]');
    var subscribeButtons = document.querySelectorAll('.subx__subscribe-btn, .subx-subscribe-btn');
    var stickyBtns = document.querySelectorAll('.nupi-sticky-atc-btn');

    if (type === 'onetime') {
      // 1. Regular purchase
      if (oneTimeRadio) oneTimeRadio.checked = true;
      if (subsHeaderRadio) subsHeaderRadio.checked = false;

      if (oneTimeLabel) oneTimeLabel.classList.add('subx-is-active');
      if (subxGroup) subxGroup.classList.remove('subx-is-active');

      planCards.forEach(function(card) {
        card.classList.remove('subx-is-active');
        var r = card.querySelector('input[type="radio"]');
        if (r) r.checked = false;
      });

      // Clear selling_plan on product forms
      var forms = document.querySelectorAll('form[action*="/cart/add"], product-form form, .product-form form');
      forms.forEach(function(form) {
        form.setAttribute('data-purchase-type', 'onetime');
        form.classList.remove('subx--subscription-active');
        var spInput = form.querySelector('input[name="selling_plan"]');
        if (spInput) spInput.value = '';
      });

      // Buttons: Show ATC + Buy Now, Hide Subscribe Now
      atcButtons.forEach(function(btn) {
        btn.style.setProperty('display', 'inline-flex', 'important');
        btn.style.setProperty('flex', '1 1 calc(50% - 6px)', 'important');
        btn.style.setProperty('width', 'calc(50% - 6px)', 'important');
        btn.style.setProperty('max-width', 'calc(50% - 6px)', 'important');
      });
      buyNowButtons.forEach(function(btn) {
        btn.style.setProperty('display', 'inline-flex', 'important');
        btn.style.setProperty('flex', '1 1 calc(50% - 6px)', 'important');
        btn.style.setProperty('width', 'calc(50% - 6px)', 'important');
        btn.style.setProperty('max-width', 'calc(50% - 6px)', 'important');
      });
      subscribeButtons.forEach(function(btn) {
        btn.style.setProperty('display', 'none', 'important');
      });
      stickyBtns.forEach(function(sBtn) {
        var textEl = sBtn.querySelector('.nupi-sticky-atc-text');
        if (textEl && !sBtn.classList.contains('is-loading') && !sBtn.classList.contains('is-success')) {
          textEl.textContent = 'ADD TO CART';
        }
      });

      if (oneTimeRadio) {
        oneTimeRadio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    } else if (type === 'subscription') {
      // 2. Subscription (Monthly, Quarterly, or Yearly)
      if (oneTimeRadio) oneTimeRadio.checked = false;
      if (subsHeaderRadio) subsHeaderRadio.checked = true;

      if (oneTimeLabel) oneTimeLabel.classList.remove('subx-is-active');
      if (subxGroup) subxGroup.classList.add('subx-is-active');

      // Determine which plan card is target
      var activeCard = null;
      if (typeof targetCardIndex === 'number' && planCards[targetCardIndex]) {
        activeCard = planCards[targetCardIndex];
      } else {
        // Find existing checked card, or fallback to Monthly (first card)
        planCards.forEach(function(c) {
          var r = c.querySelector('input[type="radio"]');
          if (r && r.checked) activeCard = c;
        });
        if (!activeCard && planCards.length > 0) {
          activeCard = subsection.querySelector('.subx-card--monthly') || planCards[0];
        }
      }

      var activeRadio = null;
      planCards.forEach(function(card) {
        var r = card.querySelector('input[type="radio"]');
        if (card === activeCard) {
          card.classList.add('subx-is-active');
          if (r) {
            r.checked = true;
            activeRadio = r;
          }
        } else {
          card.classList.remove('subx-is-active');
          if (r) r.checked = false;
        }
      });

      // Update selling_plan on forms
      if (activeRadio) {
        var spId = activeRadio.dataset.sellingPlanId || activeRadio.value || '';
        var forms = document.querySelectorAll('form[action*="/cart/add"], product-form form, .product-form form');
        forms.forEach(function(form) {
          form.setAttribute('data-purchase-type', 'subscription');
          form.classList.add('subx--subscription-active');
          var spInput = form.querySelector('input[name="selling_plan"]');
          if (!spInput) {
            spInput = document.createElement('input');
            spInput.type = 'hidden';
            spInput.name = 'selling_plan';
            form.appendChild(spInput);
          }
          spInput.value = spId;
        });

        // Trigger change on the active plan radio so app updates
        activeRadio.dispatchEvent(new Event('change', { bubbles: true }));
      }

      // Buttons: Hide ATC + Buy Now, Show Subscribe Now
      atcButtons.forEach(function(btn) {
        btn.style.setProperty('display', 'none', 'important');
      });
      buyNowButtons.forEach(function(btn) {
        btn.style.setProperty('display', 'none', 'important');
      });
      subscribeButtons.forEach(function(btn) {
        btn.style.setProperty('display', 'inline-flex', 'important');
        btn.style.setProperty('flex', '1 1 100%', 'important');
        btn.style.setProperty('width', '100%', 'important');
        btn.style.setProperty('max-width', '100%', 'important');
      });
      stickyBtns.forEach(function(sBtn) {
        var textEl = sBtn.querySelector('.nupi-sticky-atc-text');
        if (textEl && !sBtn.classList.contains('is-loading') && !sBtn.classList.contains('is-success')) {
          textEl.textContent = 'SUBSCRIBE NOW';
        }
      });

      if (window.SUBX && typeof window.SUBX.toggleSubscribeButton === 'function') {
        window.SUBX.toggleSubscribeButton();
      }
    }

    formatDiscountBadges(subsection);
    formatPrices(subsection);
    formatSubtitles(subsection);
  }

  function enhanceWidget() {
    var subsection = document.querySelector('.easymanualsubsection');
    if (!subsection) return;

    // 1. Regular purchase enhancement
    var oneTimeLabel = subsection.querySelector('.easymsgonetimelabel');
    if (oneTimeLabel) {
      var inputContainer = oneTimeLabel.querySelector('.easymsginputcontainer');
      var heading = oneTimeLabel.querySelector('.easywidgetheading');
      if (inputContainer && heading) {
        if (!inputContainer.querySelector('.subx-text-col')) {
          var textCol = document.createElement('div');
          textCol.className = 'subx-text-col';
          heading.parentNode.insertBefore(textCol, heading);
          textCol.appendChild(heading);

          var subtitle = document.createElement('span');
          subtitle.className = 'subx-subtitle';
          subtitle.textContent = 'One-time purchase';
          textCol.appendChild(subtitle);
        }

        if (!inputContainer.querySelector('.subx-icon-wrap--cart')) {
          var textColEl = inputContainer.querySelector('.subx-text-col');
          if (textColEl) {
            var existingSvg = inputContainer.querySelector('.subx-icon--cart');
            if (existingSvg && existingSvg.parentNode === inputContainer) {
              existingSvg.remove();
            }
            textColEl.insertAdjacentHTML('beforebegin', CART_ICON_SVG);
          }
        }
      }
    }

    // 2. Subscribe & Save header row enhancement
    var subsPlanLabel = subsection.querySelector('.easymsgsubsplanlabel');
    if (subsPlanLabel) {
      var subInputContainer = subsPlanLabel.querySelector('.easymsginputcontainer');
      var subHeading = subsPlanLabel.querySelector('.easywidgetheading');
      if (subInputContainer && subHeading) {
        if (!subInputContainer.querySelector('.subx-text-col')) {
          var subTextCol = document.createElement('div');
          subTextCol.className = 'subx-text-col';
          subHeading.parentNode.insertBefore(subTextCol, subHeading);
          subTextCol.appendChild(subHeading);

          var subSubtitle = document.createElement('span');
          subSubtitle.className = 'subx-subtitle';
          subSubtitle.textContent = 'Get automatic deliveries and save more';
          subTextCol.appendChild(subSubtitle);
        }

        if (!subInputContainer.querySelector('.subx-icon-badge--green')) {
          var subTextColEl = subInputContainer.querySelector('.subx-text-col');
          if (subTextColEl) {
            subTextColEl.insertAdjacentHTML('beforebegin', REFRESH_ICON_SVG);
          }
        }
      }
    }

    // 3. Plan items enhancement
    var planCards = subsection.querySelectorAll('.easymsgsubsplanlistcontainerlabCon');
    planCards.forEach(function(card) {
      var label = card.querySelector('.easymsgsubsplanlistcontainerlabel');
      if (!label) return;

      var inputWrap = label.querySelector('.easysellingplanitemsinput');
      var textWrap = label.querySelector('.easysellingplannametextwrap');
      var nameText = label.querySelector('.easysellingplannametext');
      var priceWrap = label.querySelector('.easysellingplanitemsprice');
      var planName = (nameText ? nameText.textContent : '').toLowerCase();

      var isMonthly = planName.includes('month') && !planName.includes('quarter') && !planName.includes('3') && !planName.includes('year') && !planName.includes('12');

      // Ensure discount badge is positioned inside label immediately before priceWrap
      // Layout order: Column 1 (Title & Radio on Left), Column 2 (SAVE 15% in Center), Column 3 (Price on Right)
      var discountBadge = card.querySelector('.easydiscountbadge');
      if (discountBadge && priceWrap) {
        if (discountBadge.parentElement !== label || discountBadge.nextElementSibling !== priceWrap) {
          label.insertBefore(discountBadge, priceWrap);
        }
      }

      // Neutralize any purple icons to green
      var purpleBadge = card.querySelector('.subx-icon-badge--purple');
      if (purpleBadge) {
        purpleBadge.classList.remove('subx-icon-badge--purple');
        purpleBadge.classList.add('subx-icon-badge--green');
        var svg = purpleBadge.querySelector('svg');
        if (svg) svg.setAttribute('stroke', '#284835');
      }

      if (isMonthly) {
        card.classList.add('subx-card--monthly');
        card.classList.remove('subx-card--prepaid');

        // Floating "Most Popular" pill badge
        if (!card.querySelector('.subx-popular-badge')) {
          var popularBadge = document.createElement('span');
          popularBadge.className = 'subx-popular-badge';
          popularBadge.textContent = 'Most Popular';
          card.appendChild(popularBadge);
        }

        // Subtitle "Get delivery every 1 month"
        if (textWrap && !textWrap.querySelector('.easysellingplanprepaidinfo')) {
          var sub = document.createElement('p');
          sub.className = 'easysellingplanprepaidinfo subx-monthly-sub';
          sub.textContent = 'Get delivery every 1 month';
          textWrap.appendChild(sub);
        }

        // REMOVE any discount badge from Monthly (app original status: no discount on monthly)
        var monthlyDiscountBadges = card.querySelectorAll('.easydiscountbadge, .subx-monthly-badge');
        monthlyDiscountBadges.forEach(function(b) {
          b.remove();
        });

        // Calendar Icon (Green)
        if (inputWrap && !inputWrap.querySelector('.subx-icon-badge')) {
          if (textWrap) {
            textWrap.insertAdjacentHTML('beforebegin', CALENDAR_GREEN_SVG);
          }
        }

        // Add "/each" to price without strikethrough
        if (priceWrap && !priceWrap.querySelector('.esa-each-text')) {
          var eachSpan = document.createElement('span');
          eachSpan.className = 'easysmallspan esa-each-text';
          eachSpan.textContent = '/each';
          eachSpan.style.setProperty('text-decoration', 'none', 'important');
          eachSpan.style.setProperty('-webkit-text-decoration', 'none', 'important');
          priceWrap.appendChild(eachSpan);
        }
      } else {
        card.classList.add('subx-card--prepaid');
        card.classList.remove('subx-card--monthly');

        // Calendar Icon (Unified Green) for Quarterly / Yearly
        if (inputWrap && !inputWrap.querySelector('.subx-icon-badge')) {
          if (textWrap) {
            textWrap.insertAdjacentHTML('beforebegin', CALENDAR_GREEN_SVG);
          }
        }
      }
    });

    formatDiscountBadges(subsection);
    formatPrices(subsection);
    formatSubtitles(subsection);
    ensureSubscribeButton();
  }

  // Set default selection to REGULAR PURCHASE on initial load (as requested)
  function setDefaultSelection() {
    var subsection = document.querySelector('.easymanualsubsection');
    if (!subsection) return;

    if (!userHasInteracted) {
      selectPurchaseOption('onetime');
    }
  }

  // Handle user clicks & changes smoothly with event delegation
  function attachEvents() {
    var subsection = document.querySelector('.easymanualsubsection');
    if (!subsection || subsection._subxEventsBound) return;
    subsection._subxEventsBound = true;

    // Click delegation
    subsection.addEventListener('click', function(e) {
      userHasInteracted = true;
      var target = e.target;

      // 1. Regular purchase card clicked
      if (target.closest('.easymsgonetimecontainer, .easymsgonetimelabel')) {
        selectPurchaseOption('onetime');
        return;
      }

      // 2. Specific plan card clicked (Monthly, Quarterly, Yearly)
      var planCard = target.closest('.easymsgsubsplanlistcontainerlabCon');
      if (planCard) {
        var allCards = Array.from(subsection.querySelectorAll('.easymsgsubsplanlistcontainerlabCon'));
        var idx = allCards.indexOf(planCard);
        if (idx !== -1) {
          selectPurchaseOption('subscription', idx);
        }
        return;
      }

      // 3. Subscribe & Save header row clicked
      if (target.closest('.easymsgsubsplancontainer, .easymsgsubsplanlabel')) {
        selectPurchaseOption('subscription');
        return;
      }
    });

    // Change delegation for radio buttons
    subsection.addEventListener('change', function(e) {
      userHasInteracted = true;
      var target = e.target;

      if (target.closest('.easymsgonetimecontainer')) {
        selectPurchaseOption('onetime');
      } else if (target.classList && target.classList.contains('easymsgsamllradio')) {
        var allCards = Array.from(subsection.querySelectorAll('.easymsgsubsplanlistcontainerlabCon'));
        var planCard = target.closest('.easymsgsubsplanlistcontainerlabCon');
        var idx = allCards.indexOf(planCard);
        selectPurchaseOption('subscription', idx !== -1 ? idx : 0);
      } else if (target.closest('.easymsgsubsplancontainer')) {
        selectPurchaseOption('subscription');
      }
    });
  }

  // Expose enhanceWidget globally so variant pickers and popup script can invoke it directly
  window.enhanceSubscriptionWidget = function() {
    enhanceWidget();
    attachEvents();
  };

  function triggerEnhanceCascade() {
    enhanceWidget();
    attachEvents();
    setTimeout(function() { enhanceWidget(); attachEvents(); }, 50);
    setTimeout(function() { enhanceWidget(); attachEvents(); }, 150);
    setTimeout(function() { enhanceWidget(); attachEvents(); }, 300);
    setTimeout(function() { enhanceWidget(); attachEvents(); }, 600);
  }

  // Initialize & Observe for dynamic widget updates (e.g. variant switches)
  function init() {
    enhanceWidget();
    setDefaultSelection();
    attachEvents();

    // Re-check regular selection after 300ms and 700ms if user hasn't touched the widget yet
    setTimeout(function() {
      if (!userHasInteracted) setDefaultSelection();
    }, 300);
    setTimeout(function() {
      if (!userHasInteracted) setDefaultSelection();
    }, 700);

    // Listen to all variant change triggers across the entire theme
    ['variant:changed', 'variant:change', 'subx:variant-change', 'subx:purchase-option-change', 'subx:selling-plan-change'].forEach(function(evtName) {
      document.addEventListener(evtName, triggerEnhanceCascade);
    });
    window.addEventListener('popstate', triggerEnhanceCascade);

    // Observe permanent ancestor container (never detaches when app replaces .easymanualsubsection)
    var parentContainer = document.querySelector('[id*="easy_subscriptions"], .shopify-app-block') || document.body;
    var observerDebounce = null;
    var observer = new MutationObserver(function() {
      clearTimeout(observerDebounce);
      observerDebounce = setTimeout(function() {
        enhanceWidget();
        attachEvents();
        if (!userHasInteracted) {
          var oneTimeRadio = document.querySelector('.easymsgonetimecontainer input[type="radio"], input[id^="one_time_purchase_option"]');
          if (oneTimeRadio && !oneTimeRadio.checked) {
            setDefaultSelection();
          }
        }
      }, 40);
    });

    observer.observe(parentContainer, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('load', function() {
    triggerEnhanceCascade();
    if (!userHasInteracted) setDefaultSelection();
  });
})();
